import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ActivatedRoute } from '@angular/router';
declare const swal: any;

@Component({
  selector: 'trainer-feedback-form',
  templateUrl: './trainer-feedback-form.component.html',
  styleUrls: ['./trainer-feedback-form.component.css']
})
export class TrainerFeedbackFormComponent implements OnInit {
  @Input() batchDetails: any;
  feedbackForm: FormGroup
  trainerFeedBackForm: FormGroup
  questions: any = [];
  loggedInUserName: any;
  role: any;
  isUpdate: boolean;
  constructor(
    private location: Location,
    private utilityService: UtilityServiceService,
    private fb: FormBuilder,
    private currentUserService: CurrentUserService,
    private router: ActivatedRoute
  ) {
    this.trainerFeedBackForm = this.fb.group({
			feedbacks: fb.array([])
    });
    this.currentUserService.getCurrentUser().subscribe(res => {
      this.loggedInUserName = res && res.userName;
      this.role = res && res.role;
    })

    if (this.role === 'Continuous Monitoring' || this.role === 'Fee Based DA') {
      this.router.params.subscribe(params => {
        this.loggedInUserName = params.tpId;
        this.getQuestionsForCandidate();
      });      // this.loggedInUserName = this.batchDetails && this.batchDetails.candidates && this.batchDetails.candidates.candidateId
    } else {
      this.getQuestionsForCandidate();

    }
  }

  get candidate(): FormArray {
		return this.trainerFeedBackForm.get('feedbacks') as FormArray;
  }

  createTrainerForm(data) {
		return this.fb.group({
      feedback: this.fb.group({
        id: data.id,
				question: [data.questionString],
        choice: [null,[Validators.required]],
        others: [],
			})
		});
	}
  ngOnInit() {
    this.feedbackForm = this.fb.group({
      feedback: this.fb.array([])
    })
    console.log(this.batchDetails)
    // this.getQuestionsForCandidate();

  }


  createFeedbackForm(data): FormGroup {
    return this.fb.group({
      questions: [data.questionString],
      answer: [],
    })
  }


  getQuestionsForCandidate() {
    this.utilityService.getMasterQuestion('TREB').subscribe(res => {
      this.questions = res && res.data || [];
      console.log(this.questions)
      for (let index = 0; index < this.questions.length; index++) {
        this.candidate.push(this.createTrainerForm(this.questions[index]));
      }
      this.getFeedback();
    })
    console.log('FORM', this.feedbackForm)

  }

  sumitFeedback() {
    if (this.isUpdate) {
      swal({
        title: 'Are You Sure, You want to Update?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.updateFeedback(this.batchDetails.batchId, this.loggedInUserName,'TREB',this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Updated');
            this.goBack();
          })
        }
      })
    } else {
      swal({
        title: 'Are You Sure, You want to submit?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.addFeedback(this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Submitted');
            this.goBack();
          })
        }
      })
    }


  }

  getFeedback() {
    if (this.role === 'Trainer') {
      this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'TREB').subscribe(res => {
        console.log(res)
        const feedbackData = res && res.data && res.data.feedback || []
        if (feedbackData.length > 0) {
          this.isUpdate = true;
        }
        if (feedbackData.length > 0) {
          for (let index = 0; index < feedbackData.length; index++) {
            this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            if (this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('id').value === 'Q4') {
              if (this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').value === false) {
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').disable()
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').setValidators([])
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').updateValueAndValidity();
              }
            }
          }
        }
      })
    } else {
      this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'TREB').subscribe(res => {
        console.log(res)
        const feedbackData = res && res.data && res.data.feedback || []
        if (feedbackData.length > 0) {
          this.isUpdate = true;
        }
        if (feedbackData.length > 0) {
          for (let index = 0; index < feedbackData.length; index++) {
            this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);

            if (this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('id').value === 'Q4') {
              if (this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').value === false) {
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').disable()
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').setValidators([])
                this.trainerFeedBackForm.get('feedbacks')['controls'][index + 1].get('feedback').get('choice').updateValueAndValidity();
              }
            }
            this.trainerFeedBackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()

          }
        }
      })
    }

  }

  displayQuestion(qId,question) {
    if (qId === 'Q1') {
      const jobRoleName = this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || ''

      let replacedString = question.replace("[Job role name]", `"${jobRoleName}"`);
      return replacedString
    } else if (qId === 'Q2') {
      const jobRoleName = this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || ''
      let replacedString = question.replace("[Job role name]", `"${jobRoleName}"`);
      return replacedString
    } else if (qId === 'Q3') {
      const jobRoleName = this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || ''
      let replacedString = question.replace("[Job role name]", `"${jobRoleName}"`);
      return replacedString
    }
    else {
      return question
    }
  }
  mapPayload() {
    const elements = (this.trainerFeedBackForm.getRawValue().feedbacks) || [];
    const mapElements = elements.map(element => ({
      question: element && element.feedback && element.feedback.question,
      answer: element && element.feedback && element.feedback.choice,
      others: element && element.feedback && element.feedback.others

    }))
    const DATA = {
      tpName: this.batchDetails && this.batchDetails.tpName || '',
      tcName: this.batchDetails && this.batchDetails.tcName || '',
      tpId: this.batchDetails && this.batchDetails.tpId || '',
      tcId: this.batchDetails && this.batchDetails.tcId || '',
      qpCode: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].qpCode || '',
      jobRoleDesc: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobRoleDesc || '',
      jobName: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || '',
      batchId: this.batchDetails && this.batchDetails.batchId,
      createdBy: this.loggedInUserName,
      type: 'TREB',
      feedback: mapElements
    }
    return DATA
  }

  goBack() {
    this.location.back()

  }

  validate(i) {
    const selectedChoice = this.trainerFeedBackForm.get('feedbacks')['controls'][i].get('feedback').value
    if (selectedChoice && selectedChoice.id === 'Q4') {
      if (selectedChoice && selectedChoice.choice === false) {
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').reset()
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').disable()
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').setValidators([])
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').updateValueAndValidity()
      } else {
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').enable()
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').setValidators([Validators.required])
        this.trainerFeedBackForm.get('feedbacks')['controls'][i+1].get('feedback').get('choice').updateValueAndValidity()
      }
    }
  }

  reset() {
    this.trainerFeedBackForm.reset();
  }
}
